export default {
  desc: [], // { language: null, '#text': null }
  id: null,
  name: [], // { language: null, '#text': null }
  type: null
}
